import { useState } from "react";
import axios from "axios";
import { useParams, useLocation } from "react-router-dom";
import styles from "../houseManagerProfile.module.css";
import useProfileData from "./hooks/useProfileData";


const baseURL = `${process.env.REACT_APP_API_URL}`

export default function Messaging () {
    const { profile } = useProfileData();
    const [message, setMessage] = useState('');
    const [showContactForm, setShowContactForm] = useState(false);
    const { id } = useParams();

    const handleSendMessage = () => {
        if (!message.trim()) {
            console.error('Message cannot be empty')
            return;
        }
        const token = localStorage.getItem('accessToken');
        if (!token) {
            console.error('AccessToken not found in localStorage');
        }
        console.log('AccessToken:', token)
        axios
            .post(
            `${baseURL}/profiles/contact-house-manager/`,
            {
                houseManagerId: id,
                message,
            },
            {
                headers: {
                Authorization: `Bearer ${token}`,
                },
            }
            )
            .then(() => {
            // setSuccess("Message sent successfully");
            setMessage("");
            setShowContactForm(false);
            })
            .catch((error) => {
            console.error('Error sending message:', error)
            if (error.response && error.response.status === 401) {
                console.error("Unauthorized: Please log in again")
            } else {
                console.error("Error has occurred while sending your message");
            }
            });

    };

    return (
        <>
            { showContactForm && (
                <div className={styles.contactForm}>
                <h2>Contact {profile.first_name}</h2>
                <textarea
                    className={styles.messageInput}
                    placeholder="Write your message"
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                />
                <div className={styles.formButton}>
                    <button className={styles.sendButton} onClick={handleSendMessage}>
                    Send Message
                    </button>
                    <button className={styles.cancelButton} onClick={() => setShowContactForm(false)}>
                    Cancel
                    </button>
                </div>
                </div>
            ) }
        </>
    )
}